import React from 'react';
import { connect } from 'react-redux';

import IconButton from 'material-ui/IconButton';
import PrevIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import NextIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-right';

import Slider from './slider';

import arrayLoop from '../../utils/loop';

import './index.css';

class Carousel extends React.Component {

	componentWillMount () {
		this.sCounter = 0;
	}

	componentDidMount () {
		this.el = document.getElementsByClassName(`gohire-thread-carousel-${this.props.index}`)[0];
		this.sliderCount = this.el.children.length;

		if (this.sliderCount === 1) {
			this.el.parentNode.parentNode.querySelector('div.gohire-thread-carousel-nav-next').style.display = 'none';
		}
	}

	navCa = dir => event => {
		let el = document.getElementsByClassName(`gohire-thread-carousel-${this.props.index}`)[0];
		let basis = window.getComputedStyle(el)['flex-basis'].split('px')[0];
		let sliderCount = el.children.length;

		let regex = /\((.*)px/;
		let trans = el.style.transform;
		let value = (trans.match(regex) || [] )[1] || 0;

		const obj = {
			next: [+value - +basis, this.sCounter + 1, 'gohire-thread-carousel-nav-next', 'gohire-thread-carousel-nav-prev'],
			prev: [+value + +basis, this.sCounter - 1, 'gohire-thread-carousel-nav-prev', 'gohire-thread-carousel-nav-next'],
		};

		let final = obj[dir][0];

		this.sCounter = obj[dir][1];

		if (this.sCounter + 1 === sliderCount || this.sCounter === 0) {
			el.parentNode.parentNode.querySelector(`div.${obj[dir][2]}`).style.visibility = 'hidden';
		}

		el.parentNode.parentNode.querySelector(`div.${obj[dir][3]}`).style.visibility = 'visible';

		// set inline style
		el.style.transform = `translateX(${final}px)`;
	}

	render() {
		const styles = {
			iconBtn: {
				width: 68,
				height: 68,
				transition: 'none',
			},
			iconStyle: {
				width: 48,
				height: 48,
				color: '#808080',
				transition: 'none',
			},
		};

		const slides = [];

		arrayLoop(this.props.cards, (slide, index) => {
			slides.push(<Slider key={index} data={slide} />);
		});

		let classC = `gohire-thread-carousel-wrapper gohire-thread-carousel-${this.props.index}`;

		return (
			<div className="gohire-thread-card-wrapper pull-right">
				<div className="gohire-thread-card-body">
					<div className="gohire-thread-carousel">
						<div className={classC}>
							{slides}
						</div>
					</div>
					<div className="gohire-thread-carousel-nav">
						<div className="gohire-thread-carousel-nav-prev" style={{visibility: 'hidden'}}>
							<IconButton
								onClick={this.navCa('prev')}
								iconStyle={styles.iconStyle}
								style={styles.iconBtn}
							>
								<PrevIcon/>
							</IconButton>
						</div>
						<div className="gohire-thread-carousel-nav-next">
							<IconButton
								onClick={this.navCa('next')}
								iconStyle={styles.iconStyle}
								style={styles.iconBtn}
							>
								<NextIcon/>
							</IconButton>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Carousel);
